import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { FormInput } from "../../FormComponents/Input/Input";
import { Dropdown } from "../../FormComponents/Dropdown";

export default function CompensationTicketForm({ form, onChange, isEditable }) {
    const { t } = useTranslation();
    const { data } = form;

    const results = useSelector(state => state.CommonReducer.dropdownlists?.['CompensationResults']) ?? [];
    const subResults = results.find(r => r.id === Number(data?.resultId))?.subOptions ?? [];

    const onResultChange = (value) => {
        onChange("resultId", value);
        onChange("subResultId", results.find(r => r.id === Number(value))?.subOptions[0]?.id ?? null);
    }

    return (
        <form className={`form-horizontal col-6`}>
            <fieldset className={`d-grid col-12 gap-16 ${isEditable ? "" : "disabled"}`}>
                <FormInput
                    required={isEditable}
                    label={t("settingscompensationeditcontainer.sum")}
                    value={data.sum}
                    onChange={value => onChange("sum", value)}
                />
                <Dropdown
                    required={isEditable}
                    label={t("settingscompensationeditcontainer.compensationresult")}
                    onChange={onResultChange}
                    options={results}
                    value={data.resultId}
                />
                {subResults.length > 0 &&
                    <Dropdown label={t("settingscompensationeditcontainer.compensationsubresult")}
                        onChange={value => onChange("subResultId", value)}
                        options={subResults}
                        value={data.subResultId}
                    />
                }
                <FormInput
                    required={isEditable}
                    type="textarea"
                    label={t("settingscompensationeditcontainer.comment")}
                    value={data.comment}
                    onChange={value => onChange("comment", value)}
                />
            </fieldset>
        </form>
    )
}